import React from 'react'

export default function FreetextIcon({ color = null }) {
  return (
    <svg
      width="13px"
      height="17px"
      viewBox="0 0 13 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ color }}
    >
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g transform="translate(-18.000000, -16.000000)" fill="currentColor">
          <polygon points="18 16 30.6285714 16 30.6285714 20.4442857 28.8314286 20.4442857 28.8314286 17.7971429 25.31 17.7971429 25.31 31.2028571 27.9814286 31.2028571 27.9814286 33 20.6228571 33 20.6228571 31.2028571 23.2942857 31.2028571 23.2942857 17.7971429 19.7971429 17.7971429 19.7971429 20.4442857 18 20.4442857" />
        </g>
      </g>
    </svg>
  )
}
